import {Box} from "@mui/material";
import {theme} from "../../themes/theme";
import CakeRoundedIcon from '@mui/icons-material/CakeRounded';

interface ICustomItemDetialAvatar{
    iconAvatar: React.ReactNode;
}
export const CustomItemDetialAvatar = ({iconAvatar}:ICustomItemDetialAvatar) => {
    return (
        <Box sx={{
            border:`0.8px ${theme.palette.common.black} solid`,
            width:"5.625rem",
            height:"5rem",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            borderRadius:"0.5rem"
        }}>
            {iconAvatar}

        </Box>
    );
};